import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import variables from '@/styles/variables.scss'

import '@mdi/font/css/materialdesignicons.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: variables.primary,
        secondary: '#DF9450',
        accent: '#8c9eff'
      },
      dark: {
        primary: variables.primary,
        secondary: '#DF9450',
        accent: '#8c9eff'
      }
    }
  },
  icons: {
    // iconFont: 'md',
    iconfont: 'fa'
  }
})
